import { CheckDone01 } from '@kula-ai/icons/dual-tone/CheckDone01';
import { AlignLeft } from '@kula-ai/icons/dual-tone/AlignLeft';
import { TextInput } from '@kula-ai/icons/dual-tone/TextInput';
import { Calendar } from '@kula-ai/icons/dual-tone/Calendar';
import { Calculator } from '@kula-ai/icons/outline/Calculator';
import { Dotpoints02 } from '@kula-ai/icons/outline/Dotpoints02';
import { CurrencyDollar } from '@kula-ai/icons/outline/CurrencyDollar';
import { SingleText } from '@kula-ai/icons/outline/SingleText';
import { CurrencyRange } from '@kula-ai/icons/outline/CurrencyRange';
import { Mail01 } from '@kula-ai/icons/outline/Mail01';
import { Phone } from '@kula-ai/icons/outline/Phone';
import { Upload04 } from '@kula-ai/icons/outline/Upload04';
import { AlignJustify } from '@kula-ai/icons/outline/AlignJustify';
import { ChevronSelectorVertical } from '@kula-ai/icons/outline/ChevronSelectorVertical';
import { Location } from 'react-iconly';
import { Bs123 } from 'react-icons/bs';
import { List } from '@kula-ai/icons/dual-tone/List';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { Bold02 } from '@kula-ai/icons/outline/Bold02';

export const customFieldsIconMap = {
  string: HiOutlineMenuAlt2,
  email: Mail01,
  phone: Phone,
  address: Location,
  rel_file: Upload04,
  singleText: SingleText,
  rel_file_multiple: Dotpoints02,
  complex: AlignJustify,
  rel_tag: ChevronSelectorVertical,
  rel_tag_multi: CheckDone01,
  text: AlignLeft,
  currency: CurrencyDollar,
  number: Bs123,
  range: CurrencyRange,
  enum_boolean: CheckDone01,
  radio2: CheckDone01,
  textArea: AlignLeft,
  url: TextInput,
  date: Calendar,
  numberRange: Calculator,
  multiSelect: CheckDone01,
  integer: Dotpoints02,
  decimal: Bs123,
  composite: Dotpoints02,
  // VONQ Direct Apply question types
  choice: ChevronSelectorVertical,
  file: Upload04,
  textarea: AlignLeft,
  richtext: Bold02,
};

const commonProps = {
  iconProps: { color: 'secondary-700', h: '30px' },
};

export const customFieldOptions = ({ isAppForm }) =>
  [
    {
      value: 'string',
      label: 'Short Text',
      type: 'input',
      maxLength: 255,
      icon: HiOutlineMenuAlt2,
      ...commonProps,
    },
    // enable if wanted
    // {
    //   value: 'email',
    //   label: 'Email',
    //   type: 'input',
    //   icon: Mail01,
    //   ...commonProps,
    // },
    {
      value: 'text',
      label: 'Long Text',
      type: 'textArea',
      icon: AlignLeft,
      ...commonProps,
    },
    {
      value: 'enum_boolean',
      label: 'Yes/No',
      type: 'radio2',
      icon: CheckDone01,
      ...commonProps,
    },
    {
      value: 'rel_tag',
      label: 'Single select',
      type: 'select',
      icon: List,
      ...commonProps,
    },
    {
      value: 'rel_tag_multi',
      label: 'Multi Select',
      type: 'select',
      icon: List,
      ...commonProps,
    },
    // {
    //   value: 'rel_tag_multi',
    //   label: 'Single select',
    //   type: 'select',
    //   icon: Dropdown,
    //   ...commonProps,
    // },
    // {
    //   value: 'currency',
    //   label: 'Currency',
    //   icon: CurrencyDollar,
    //   ...commonProps,
    // },
    // {
    //   value: 'currencyRange',
    //   label: 'Currency Range',
    //   icon: CurrencyRange,
    //   ...commonProps,
    // },
    {
      value: 'number',
      label: 'Number',
      // icon: Number,
      icon: Bs123,
      ...commonProps,
    },
    // {
    //   value: 'numberRange',
    //   label: 'Number Range',
    //   icon: Calculator,
    //   ...commonProps,
    // },
    {
      value: 'date',
      label: 'Date',
      icon: Calendar,
      ...commonProps,
    },
    {
      value: 'url',
      label: 'URL',
      icon: TextInput,
      maxLength: 255,
      ...commonProps,
    },
    isAppForm && {
      value: 'rel_file',
      label: 'File',
      type: 'upload',
      icon: Upload04,
      ...commonProps,
    },
    {
      value: 'richtext',
      label: 'Rich Text',
      type: 'editor',
      icon: Bold02,
      ...commonProps,
    },
  ].filter(Boolean);
